// extracted by mini-css-extract-plugin
module.exports = {"mainCont":"style_mainCont__19Sq-","breadcrumb":"style_breadcrumb__1fQDu","link":"style_link__2dnlf"};